<template>
    <div :class="expanded ? 'white-box-expanded' : 'white-box'">
        <div v-if="show_logo == 1" class="login-logo">
            <el-image v-if="logo_src" fit="cover" class="login-logo-img" :src="`${this.logo_src}`" />
            <el-image v-else fit="cover" class="login-logo-img" :src="`${this.crm_public_path}${this.restaurantInfo.logoImgKey}`" />
        </div>
        <div v-if="!show_logo && !is_profile" class="login-logo">
            <el-image fit="cover" class="login-logo-img" :src="require('@assets/img/icon-change-phone.jpg')" />
        </div>
        <div v-if="title" class="title" v-html="title" />
        <div v-if="sub_title" class="sub-title" v-html="sub_title"></div>
        <slot />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        title: {
            type: String,
            default: () => null
        },
        sub_title: {
            type: String,
            default: () => null
        },
        show_logo: {
            type: Boolean,
            default: () => false
        },
        logo_src: {
            type: String,
            default: () => null
        },
        expanded: {
            type: Boolean,
            default: () => false
        },
        is_profile: {
            type: Boolean,
            default: () => false
        }
    },
    data () {
        return {
            crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH
        }
    },
    computed: {
        ...mapGetters({
            restaurantInfo: 'restaurant/restaurantInfo'
        })
    }
}
</script>

<style scoped>
.white-box {
    background: #FFFFFF;
    border-radius: 10px;
    width: calc(100% - 95px);
    margin: 0 auto;
    padding: 22px;
    padding-bottom: 16px;
    box-shadow: 0px 0px 40px rgba(130, 136, 148, 0.1);
}

.white-box-expanded {
    position: absolute;
    width: calc(100% - 86px);
    background: #FFFFFF;
    border-radius: 10px;
    margin: 16px;
    padding: 27px;
    box-shadow: 0px 0px 40px rgba(130, 136, 148, 0.1);
}

.login-logo {
    text-align: center;
}

.login-logo-img {
    width: 68px;
    height: 68px;
    text-align: center;
    margin-top: -60px;
    border: 6px solid #FFFFFF;
    border-radius: 50%;
}

.title {
    margin-top: 10px;
    font-weight: bold;
    font-size: 24px;
    line-height: 16px;
    color: #333333;
    text-align: center;
}

.sub-title {
    font-size: 20px;
    line-height: 24px;
    color: #333333;
    margin-top: 5px;
    text-align: center;
}
</style>
